import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {WebSocketProvider} from "./net/WebSocketContext";

// Блокировка прокрутки на мобильных устройствах
document.body.style.overflow = 'hidden';
document.documentElement.style.overflow = 'hidden';

const root = ReactDOM.createRoot(document.getElementById('root'));

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").then(() => {
        console.log("✅ Service Worker зарегистрирован!");
    }).catch((err) => console.error("❌ Ошибка регистрации SW:", err));
}

root.render(
    // <React.StrictMode>
    <WebSocketProvider>
        <App/>
    </WebSocketProvider>
    // </React.StrictMode>
 );